import styled from 'styled-components'

export const StyledButton = styled.button`  
  display:flex;
  flex-flow:row nowrap;  
  justify-content:center;  
  align-items: center; 
  outline: none;
  font-size: 0.9em;
  border-radius: 24px;  
  background-color: ${(props => props.backgroundColor? props.backgroundColor : '#4285F4')};  
  color:white;
  outline:none;
  border: none;  
  width: ${(props => props.width? props.width : '100%')};  
  line-height: 50px;  
  cursor:pointer;
  margin: 8px;
  margin-bottom: 20px;
  ${'' /* z-index: 99; */}
  &:disabled {
      background-color: gray;
      color:white;
      cursor:default;
  }
` 

export const Title = styled.label`
  font-size: 18px; 
  font-weight: bold; 
  color: 'blue';  

  &:hover {    
    color: black;
  }
`

